import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import ControlsStyles from '@stories/Components/Misc/Carousel/Controls/Controls.styles';
import DotPaginationStyles from '@stories/Components/Misc/DotPagination/DotPagination.styles';
import SectionHeaderStyles from '@stories/Components/SectionHeader/SectionHeader.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  margin: var(--sectionSpacing) 0;

  &[data-background='beige'] {
    background-color: ${brand.beige};
  }

  &[data-background='green'] {
    background-color: ${brand.green};

    ${SectionHeaderStyles.Title},
    ${SectionHeaderStyles.Content},
    ${SectionHeaderStyles.Subtitle} {
      color: ${brand.white};
    }
  }

  &[data-background='beige'],
  &[data-background='green'] {
    padding: ${fluid(24, 48)} 0;
  }

  &[data-background='white'] {
    background-color: ${brand.white};
  }
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
  gap: 44px;

  @media ${from(Device.Tablet)} {
    flex-direction: row;
    justify-content: space-between;

    &[data-carousel-position='left'] {
      flex-direction: row-reverse;
    }
  }
`;
const CarouselContainer = styled.div `
  overflow: hidden;
  max-width: 980px;
  flex: 2 1;

  [data-background='green'] & {
    ${ControlsStyles.Container} {
      --controlsColour: ${brand.white};

      margin-top: 32px;
    }

    ${DotPaginationStyles.Container} {
      --colorInactive: rgba(255, 255, 255, 0.33);
      --colorActive: ${brand.white};
    }
  }
`;
const CarouselWrapper = styled.div `
  overflow: hidden;

  /* Adjust the left/right margin of the carousel wrapper by the amount of padding 
    added to cards and track wrapper to ensure that the width is correct */
  margin-left: -12px;
  margin-right: -12px;
`;
const Item = styled.li `
  flex: 0 0 100%;

  /* Ensure spacing between cards, even when full-width, or animation looks bizarre */
  padding-left: 12px;
  padding-right: 12px;
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(16, 9)};
`;
const Image = styled.img `
  ${imageCoverContainer()}
`;
const Video = styled.video `
  ${imageCoverContainer()}
`;
const ContentCarouselStyles = {
    CarouselContainer,
    CarouselWrapper,
    Container,
    Image,
    ImageWrapper,
    Inner,
    Item,
    Video,
};
export default ContentCarouselStyles;
